module.exports = __webpack_public_path__ + "img/pageIndex_bg.8fe0726b.jpg";